(function () {
    'use strict';
    var m = angular.module('common');
    m.directive('linkedText', ["$location", "path", "routeHelper", "linkedText", "recursionHelper", "$parse", "fnName", "authorizationLinkHelper", "$rootScope", function ($location, path, routeHelper, linkedText, recursionHelper, $parse, fnName, authorizationLinkHelper, $rootScope) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('common').directive('linked-text').template(),
            scope: {
                model: '=linkedText',
                options: '=?'
            },
            compile: function (element) {
                return recursionHelper.compile(element, this.link);
            },
            link: function ($scope, element, attrs) {
                $scope.routeHelper = routeHelper;
                $scope.options = $scope.options || {};
                $scope.textParts = [];
                $scope.$watch('model', function (text) {
                    if (_(text).isNull() || _(text).isUndefined()) {
                        text = '';
                    }
                    if (_(text.then).isFunction()) {
                        if ($scope.textParts.length === 0) {
                            $scope.textParts = linkedText.toParts('Loading...');
                        }
                        text.then(function (resolvedText) {
                            $scope.textParts = linkedText.toParts(resolvedText);
                        });
                    } else {
                        var parts = linkedText.toParts(text);
                        if (parts.length == $scope.textParts.length) {
                            $.extend(true, $scope.textParts, linkedText.toParts(text));
                        } else {
                            $scope.textParts = parts;
                        }
                    }
                }, true);
                $scope.onClick = function (event, part) {
                    if (!_(part.data.clickEvent).isUndefined()) {
                        event.preventDefault();
                        if (part.data.eventStopPropagation) {
                            event.stopPropagation();
                        }
                        if (part.data.clickEvent.type === 'broadcast') {
                            $rootScope.$broadcast(part.data.clickEvent.name, part.data.clickEvent);
                        } else {
                            $scope.$emit(part.data.clickEvent.name, part.data.clickEvent);
                        }
                    }
                };
                $scope.processClick = function (event, part) {
                    if (!_(part.data.clickEvent).isUndefined()) {
                        event.preventDefault();
                        if (part.data.clickEvent.name === 'reauth-office365_emails') {
                            $rootScope.$broadcast('close-modal');
                        }
                        $rootScope.$broadcast(part.data.clickEvent.name, part.data.clickEvent);
                    }
                };
                $scope.externalLinkClick = function (event, part) {
                    if (part.data.authorization) {
                        authorizationLinkHelper.onClick(event, part.data);
                    }
                };
                $scope.eventBroadcast = function (event, part) {
                    var e = part.data.event;
                    $rootScope.$broadcast(e.name, e.params);
                };
            }
        };
    }]);
}());